import { TaskTypeId } from "@/types/Tasks/TaskTypeId";

export function renderDistance(distance: number, isImperial: boolean) {
	if (distance === undefined || distance == null || isNaN(distance)) {
		return "";
	}

	if (isImperial) {
		if (distance > 5280) {
			return (distance / 5280).toFixed(2) + " miles";
		}

		return distance + "ft";
	} else {
		if (distance > 1000) {
			return (distance / 1000).toFixed(2) + "km";
		}

		return distance + "m";
	}
}

export function truncateString(
	input: string,
	length: number = 30,
	overflowText: string = "..."
) {
	if (input.length <= length) {
		return input;
	}
	const truncatedString = input.substring(0, length - overflowText.length);
	return truncatedString + overflowText;
}

/** Function to parse the task data within the action setup list display */
export function parseTaskText(task: any) {
	if (!task) return "";

	let parsedData;

	try {
		if (typeof task.taskData === "string") {
			parsedData = JSON.parse(task.taskData);
		} else {
			parsedData = task.taskData;
		}
	}catch(err) {
		console.error(`Could not parse text for task ID ${task.taskID}: `, err);

		return task.taskText || "Unknown";
	}

	switch (task.taskTypeID) {
		case TaskTypeId.Dispatch:
			return "Dispatch Guard";
		case TaskTypeId.MassNotification:
			return `Title: ${parsedData.title}`;
		case TaskTypeId.Choices:
			return `${parsedData.choiceDescription}: ${parsedData.choiceOptions.length} options, render type: ${parsedData.selectedChoice}`;
		case TaskTypeId.CallContact:
			return `Call: ${parsedData.name}`;
		case TaskTypeId.EventOutcome:
			return "Event Outcome";
		default:
			return task.taskText;
	}
}
